import { Play, Square, RotateCcw } from 'lucide-react'
import { Button } from '@/components/ui'
import { cn } from '@/lib/utils'

interface TimerControlsProps {
  isRunning: boolean
  onStart: () => void
  onStop: () => void
  onReset: () => void
  disabled?: boolean
  size?: 'default' | 'sm' | 'lg'
}

export function TimerControls({
  isRunning,
  onStart,
  onStop,
  onReset,
  disabled,
  size = 'default',
}: TimerControlsProps) {
  const iconSize = size === 'lg' ? 'h-6 w-6' : size === 'sm' ? 'h-3 w-3' : 'h-4 w-4'
  const buttonSize = size === 'lg' ? 'h-12 w-12' : size === 'sm' ? 'h-7 w-7' : 'h-9 w-9'

  return (
    <div className="flex items-center gap-2">
      {isRunning ? (
        <>
          <Button
            variant="destructive"
            size="icon"
            onClick={onStop}
            disabled={disabled}
            className={buttonSize}
            title="Stop timer"
          >
            <Square className={cn(iconSize, 'fill-current')} />
          </Button>
        </>
      ) : (
        <>
          <Button
            variant="default"
            size="icon"
            onClick={onStart}
            disabled={disabled}
            className={buttonSize}
            title="Start timer"
          >
            <Play className={cn(iconSize, 'fill-current')} />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={onReset}
            disabled={disabled}
            className={buttonSize}
            title="Reset timer"
          >
            <RotateCcw className={iconSize} />
          </Button>
        </>
      )}
    </div>
  )
}
